/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type cockpit_ForecastKpisDTO = {
    annual_target_cents?: number;
    ar_parent_cents?: number;
    ar_subsidy_cents?: number;
    occupancy_capacity?: number;
    occupancy_pct?: number;
    /**
     * Projected year-end minus the annual target; 0 without a target and while
     * the projection is pending.
     */
    pacing_delta_cents?: number;
    /**
     * The current year's projected year-end, the comparison basis of the next
     * year. Omitted for the current year.
     */
    prior_year_projected_cents?: number;
    /**
     * Null only before the org's first projection store run, on an
     * actuals_only request (#2192).
     */
    projected_year_end_cents: number | null;
    /**
     * Change of the next year's projected total vs prior_year_projected_cents,
     * in percent. Omitted for the current year and when the basis is zero.
     */
    projected_yoy_pct?: number;
    /**
     * Null whenever projected_year_end_cents is.
     */
    revpas_cents: number | null;
    this_month_invoiced_parent_cents?: number;
    this_month_invoiced_subsidy_cents?: number;
    uninvoiced_cents?: number;
    /**
     * What the year-over-year comparison compares: prior_year_actual (YTD
     * received, the current year) or prior_year_projected (the target year's
     * projected total vs the current year's projected year-end, the next year).
     */
    yoy_basis?: cockpit_ForecastKpisDTO.yoy_basis;
    ytd_received_cents?: number;
    /**
     * Change of YTD received vs the same span last year, in percent. Omitted when
     * the previous year has no receipts up to this month; 0 is a real flat year.
     */
    ytd_received_yoy_pct?: number;
};
export namespace cockpit_ForecastKpisDTO {
    /**
     * What the year-over-year comparison compares: prior_year_actual (YTD
     * received, the current year) or prior_year_projected (the target year's
     * projected total vs the current year's projected year-end, the next year).
     */
    export enum yoy_basis {
        PRIOR_YEAR_ACTUAL = 'prior_year_actual',
        PRIOR_YEAR_PROJECTED = 'prior_year_projected',
    }
}

